import VideoPlayer from "./components/VideoPlayer";
import AutoplayVideos from './components/AutoplayVideos';

export class Groenvermogen {
	constructor() {
		Promise.all([Groenvermogen.domReady()]).then(() => this.init());
	}
	init() {
		new AutoplayVideos();

		document.dispatchEvent(new Event('bless'));
		document.querySelectorAll('[data-video-player]').forEach((el) => new VideoPlayer(el))

		let hamburgers = document.querySelectorAll('.hamburger');
		hamburgers.forEach(function (hamburger) {
			hamburger.addEventListener(
				'click',
				function () {
					this.classList.toggle('hamburger-active');
				},
				false
			);
		});

		// SCROLL FUNCTIONS
		const scrollElement = document.getElementById('main-navigation-bar');
		const scrollOffset = 40;
		const handleScrollAnimation = () => {
			let scrollpos = window.scrollY;
			let has_scrolled = false;
			if (scrollpos > scrollOffset) {
				add_class_on_scroll();
				has_scrolled = true;
				scrollElement.classList.add('scrolled');
			} else {
				remove_class_on_scroll();
				has_scrolled = false;
				scrollElement.classList.remove('scrolled');
			}
		};

		window.addEventListener('scroll', () => {
			handleScrollAnimation();
		});

		let thenavbar = document.getElementById('main-navigation-bar');
		// was de header ooit transparant?
		const nav_was_transparent = thenavbar.classList.contains('main-navigation-transparent');

		function add_class_on_scroll() {
			scrollElement.classList.add('scrolled');
			if (nav_was_transparent) {
				scrollElement.classList.remove('main-navigation-transparent');
			}
		}

		function remove_class_on_scroll() {
			scrollElement.classList.remove('scrolled');

			if (nav_was_transparent) {
				scrollElement.classList.add('main-navigation-transparent');
			}
		}

		// Instantiate all download links on a download page
		const modalDownload = document.querySelector('#modal-download');

		if(modalDownload) {
			const myModal = new bootstrap.Modal(modalDownload, {
				keyboard: true,
			});
			document.querySelectorAll('.gv-download-link').forEach((elmodal) => {

				elmodal.addEventListener(
					'click',
					function () {
						// get the right data for this element

						const mydownloadelem = document.getElementById('download-url');
						const mydownloadtitleelem = document.getElementById('download-title');

						const dataurl = elmodal.getAttribute('data-download-url');
						const datatitle = elmodal.getAttribute('data-download-title');

						mydownloadelem.href = dataurl;
						mydownloadtitleelem.innerText = datatitle;

						myModal.show();
					},
					false
				);
			});
		}

		// Instantiate all popovers in a docs or StackBlitz page
		document.querySelectorAll('[data-bs-toggle="popover"]').forEach((elpopover) => {
			// get the right data for this element

			if (circledata.hasOwnProperty(`${elpopover.id}`)) {
				elpopover.setAttribute('data-bs-title', circledata[`${elpopover.id}`].title);
				elpopover.setAttribute('data-bs-content', circledata[`${elpopover.id}`].desc);
			}

			const mypopover = new bootstrap.Popover(elpopover, {
				trigger: 'focus',
			});
		});

	}
	
	destroy() {
        //
	}
	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new Groenvermogen();


